import script from "./DatePickerV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePickerV2.vue?vue&type=script&setup=true&lang=ts"

import "./DatePickerV2.vue?vue&type=style&index=0&id=60bb9b93&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60bb9b93"]])

export default __exports__